import {Component, Inject, OnInit, ViewChild, AfterViewInit, OnDestroy, HostListener} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import {DialogData} from '../../../auswertungen/components/auswertungen-formdialog-neu/auswertungen-formdialog-neu.component';
import {select, Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {NodeItem} from '../../../projektverwaltung/node.model';
import {AuswertungState} from '../../../auswertungen/store/reducer/auswertungen.reducer';
import {Zeitstate} from '../../store/reducer/zeiterfassung.reducer';
import {loadProjektauswahlNodesStart} from '../../../auswertungen/store/actions/getProjektauswahlNodes.actions';
import {getFilteredZeitStarted} from '../../../auswertungen/store/actions/filter-seek-date.actions';
import {ZeiterfassungStufenComponent} from '../zeiterfassung-stufen/zeiterfassung-stufen.component';
import {getFilteredSeekDateStart} from '../../store/actions/filter-seek-date.actions';
import {DashboardItem} from '../../../landingpage/dashboard.model';
import {loadProjektSelectboxStart} from '../../store/actions/project-selectbox.actions';
import {loadCacheStart} from '../../store/actions/getCacheNodes.actions';
import {Security} from '@src/app/security';



@Component({
  selector: 'app-zeiterfassung-filter',
  templateUrl: './zeiterfassung-filter.component.html',
  styleUrls: ['./zeiterfassung-filter.component.scss'],
})

export class ZeiterfassungFilterComponent implements OnInit {

  /* Ende Projekt Auswahl */
  private prjId: any;
  constructor(
    public dialogRef: MatDialogRef<ZeiterfassungFilterComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public store: Store<{ zeiterfassung: Zeitstate }>,
    public security: Security,
  )
  {
    dialogRef.disableClose = true;


    this.$projektSelectbox = store.pipe(select((state) => state.zeiterfassung.selectboxProjekte));
    this.$cache = store.pipe(select((state) => state.zeiterfassung.cacheNodes));
    this.filterForm.patchValue({
      start: this.wandler(data.start),
      ende: this.wandler(data.ende),
      offen: parseInt(data.verrechnen, 10),
    });

  }
  public $cache: Observable<DashboardItem[]>;
  public $projektSelectbox: Observable<NodeItem[]>;
  public filterForm = new FormGroup({
    start: new FormControl(''),
    cache: new FormControl(''),
    ende: new FormControl(''),
    offen: new FormControl(''),
    projektSuche: new FormControl(''),
    ferien: new FormControl('')
    });

  /* Zuweisen der Werte vom Kind in die Variable daten */
  daten;
  @ViewChild(ZeiterfassungStufenComponent) stufe;

  public disableProjektstufe: boolean;

  public getErrorMessage(Feld: string): string {
    const formControl = this.filterForm.get(Feld);
    if (formControl.hasError('required')){
      return`pages.timeDialog.formValidation.error.${Feld}.required`;
    }
    return 'pages.timeDialog.formValidation.error.generic';
  }

  // tslint:disable-next-line:typedef use-lifecycle-interface
  ngAfterViewInit() {
    this.daten = this.stufe.addButtonForm;
  }

  /* Ende Checkbox 3 */

  /* Wandelt Datum um: Ohne Zeitzone und im richtigen Backendformat */
  public wandler(date: any): any {
    const dwD = date.toLocaleString( 'en-US', { timezone: 'utc' } );
    return moment(dwD).format('YYYY-MM-DD');
  }

  public ngOnInit(): void {
    this.store.dispatch(loadProjektauswahlNodesStart());
    this.store.dispatch(loadCacheStart());
  }

  public handleSubmitClick(): void {
    this.filterForm.value.start = this.wandler(this.filterForm.value.start);
    this.filterForm.value.ende = this.wandler(this.filterForm.value.ende);
    this.filterForm.value.projektSuche = this.getLastProjektstufe();
    let searchString = 'datumVondatumBiszuverrechnen';
    if(this.filterForm.value.ferien){
      searchString = searchString + 'Ferien';
    }


    if (this.filterForm.value.projektSuche?.id === undefined){
      this.prjId = '';
    }
    else{
      this.prjId = this.filterForm.value.projektSuche.id;
    }



    // tslint:disable-next-line:max-line-length
    this.store.dispatch(getFilteredSeekDateStart({ string: searchString , item: {datumVon: this.filterForm.value.start, datumBis: this.filterForm.value.ende, zuverrechnen: this.filterForm.value.offen, projektSuche: this.prjId}}));

    sessionStorage.setItem('zeitFilterDatumVon', this.filterForm.value.start );
    sessionStorage.setItem('zeitFilterDatumBis', this.filterForm.value.ende );
    sessionStorage.setItem('zeitFilterZuverrechnen', String(this.filterForm.value.offen ? 1 : 0))  ;
    sessionStorage.setItem('zeitFilterSearchString', searchString);
    sessionStorage.setItem('zeitFilterPrjId', String(this.prjId));



    this.dialogRef.close(true);
  }

  /* Abbruchfunktion */
  // tslint:disable-next-line:typedef
  public handleCancelClick() {

    this.dialogRef.close(false);
  }

  /* holt die letzteProjektstufe */
  public getLastProjektstufe(): NodeItem{
    // tslint:disable-next-line:prefer-const
    let projektStufe;
    let letzteStufe;
    for (let i = 0; i < 1000; i++){
      const testString = 'projektStufe = this.daten.value.projektstufe' + i;
      // tslint:disable-next-line:no-eval
      eval(testString);
      if (projektStufe?.children?.length === 0){
        letzteStufe = projektStufe;
        return letzteStufe;
      }
      else if (projektStufe !== undefined && projektStufe !== ''){
        letzteStufe = projektStufe;
      }
      else{
        return letzteStufe;
      }
    }
  }

  public selectProjects(projektId: number): void {
    this.store.dispatch(loadProjektSelectboxStart({projektId}));
  }

  public setProjektstufeDisabled(checked: boolean): void{
    this.disableProjektstufe = checked;
    if(checked){
      this.filterForm.get('cache').disable();
    }
    else{
      this.filterForm.get('cache').enable();
    }
  }

}

